<h1 matDialogTitle>
  Receive Goods In Transit
</h1>

<mat-dialog-content>
  <kendo-grid [kendoGridBinding]="lines" [scrollable]="true" [resizable]="true" [reorderable]="true" [sortable]="true">

    <kendo-grid-column [width]="100" field="lineNumber" format="{0:n0}" class="td-number" title="Line Number">
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="stockCode" title="Stock Code">
    </kendo-grid-column>

    <kendo-grid-column [width]="150" field="stockDescription" title="Description">
    </kendo-grid-column>

    <kendo-grid-column [width]="150" field="availableToReceiveQty" class="td-number" title="Available To Receive Qty">
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="qty" class="td-number" title="Receive Qty">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <input matInput type="number" required [(ngModel)]="dataItem.qty" class="input-cell"
          [disabled]="dataItem.availableToReceiveQty === 0" (input)="qtyChange(dataItem)" [max]="dataItem.availableToReceiveQty" min="0">
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="150" field="note" title="Reason">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <mat-select [(ngModel)]="dataItem.note" class="input-cell" *ngIf="dataItem.qty < dataItem.availableToReceiveQty">
            <mat-option *ngFor="let shortReceiveReason of shortReceiveReasons" [value]="shortReceiveReason.value">{{shortReceiveReason.display}}</mat-option>
        </mat-select>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
</mat-dialog-content>


<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button (click)="receive()">Receive</button>
</mat-dialog-actions>